import React from 'react'
import { useTranslation } from 'react-i18next'
import IWPageHeader, {
  StyledTitle,
} from 'shared/components/thunderbolt/IWPageHeader'
import IWButton from 'shared/components/thunderbolt/IWButton'
import { FullPageMainContent, OverlayPage } from 'root/components/IWLayout'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import IWSpacer from 'shared/components/thunderbolt/IWSpacer'
import CreateAlertWizard from '../components/CreateAlertWizard'

const StyledCaretIcon = styled(FontAwesomeIcon)`
  align-self: center;
  font-size: 1rem;
  color: ${(props) => props.theme.palette.grey[400]};
`

const CreateAlertPage = () => {
  const { t } = useTranslation()
  return (
    <OverlayPage>
      <IWPageHeader data-testid="page-header" isFullScreen>
        <StyledTitle>{t('alertsManager.alerting')}</StyledTitle>
        <StyledCaretIcon icon={faChevronRight} />
        <StyledTitle>{t('alertsManager.createAlert.createAlert')}</StyledTitle>
        <IWSpacer />
        <IWButton
          as="routerNavLink"
          to="/tools/alerts-manager"
          variant="alternative"
          color="primary"
          data-testid="page-header-close-button"
        >
          {t('button.close')}
        </IWButton>
      </IWPageHeader>
      <FullPageMainContent>
        <CreateAlertWizard />
      </FullPageMainContent>
    </OverlayPage>
  )
}

export default CreateAlertPage
